<!--
 * @description: 
 * @author: Jason Wong
 * @since: 2021-12-15 10:30:09
-->
<template>
  <div
    @mouseenter="isHover = true"
    @mouseleave="isHover = false"
    @mousedown="handleRootMouseDown"
    @click="handleRootClick"
    :class="[
      'component--ribbon__button',
      `size-${size}`,
      disabled ? 'disabled' : null,
    ]"
    :title="titleText"
  >
    <div :class="['ribbon-button__image', 'flex-center', iconClass]">
      <i
        v-if="!!icon && icon.startsWith('el-')"
        :class="[icon, 'ribbon-button__image-icon']"
      ></i>
      <fa-icon
        class="ribbon-button__image-icon"
        v-else-if="
          !!icon && (icon.startsWith('fa:') || icon.startsWith('far:'))
        "
        :icon="[
          icon.substr(0, icon.indexOf(':')),
          icon.substr(icon.indexOf(':') + 1),
        ]"
      ></fa-icon>
      <slot class="ribbon-button__image-icon" v-else name="icon"></slot>
    </div>
    <div
      :class="[
        'ribbon-button__text',
        size !== 'small' && showSplitLine && isHover ? 'with-border' : null,
      ]"
    >
      <template v-if="$slots.label">
        <slot name="label"></slot>
      </template>
      <template v-else>
        <div class="ribbon-button__text-label">
          {{ labelText }}
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import ShortcutBase from "./shortcutBase";
export default {
  props: {
    size: {
      type: String,
      default: "small",
    },
    icon: {
      type: String,
    },
    iconClass: {
      type: String,
    },
    label: {
      type: String,
    },
    showSplitLine: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    title: String,
    trigger: {
      type: String,
      default: "click",
    },
  },
  mixins: [ShortcutBase],
  data() {
    return {
      isHover: false,
    };
  },
  methods: {
    handleRootClick() {
      if (this.disabled || this.trigger != "click") return;
      this.$emit("click");
    },
    handleRootMouseDown() {
      console.log("mouseDown?");
      if (this.disabled || this.trigger != "mousedown") return;
      console.log("mouseDown?");
      this.$emit("click");
    },
  },
  computed: {
    labelText() {
      return `${this.label || "-"}`;
    },
    titleText() {
      return this.title || this.shortcutTitle;
    },
    shortcutHandler() {
      return this.trigger != "mousedown"
        ? this.handleRootClick
        : this.handleRootMouseDown;
    },
  },
};
</script>

<style lang="scss">
.component--ribbon__button {
  border-radius: 2px;
  font-size: 12px;
  cursor: pointer;
  min-width: 48px;
  border: 1px solid transparent;
  padding: 0 3px;
  user-select: none;

  &:hover {
    background: #409eff1d;
    border-color: #409eff3b;
  }

  &.size-large {
    height: 100%;
    .split-line {
      border-top: 1px solid #e1e7eb;
    }

    display: flex;
    flex-direction: column;
    .ribbon-button__image {
      flex: 1;
      .ribbon-button__image-icon {
        font-size: 28px;
        margin-right: 6px;
      }
      transform: translateY(6px);
    }
    .ribbon-button__text {
      text-align: center;
      overflow: visible;
      font-size: 12px !important;
      user-select: none;
      line-height: 32px;
      border-top: 1px solid transparent;
      color: #606266;

      &.with-border {
        border-top-color: #e1e7eb;
      }
    }
  }

  &.size-small {
    padding: 0 3px;
    margin-top: 4px;
    line-height: 24px;
    > * {
      display: inline-block;
    }

    .ribbon-button__image {
      .ribbon-button__image-icon {
        margin-right: 3px;
      }
    }

    .ribbon-button__text {
      color: #606266;
    }
  }

  &.disabled {
    opacity: 0.5;
    cursor: not-allowed;

    &:hover {
      background: unset;
      border-color: transparent;
    }
  }
}
</style>